import { EGuildIncomeType } from './types'

import { Days } from '~/shared/types/base/units'

export const LIMIT_RANGE_OF_DAYS = 60 as Days
export const TABLE_ROW_CELL_BODY_HEIGHT = 90
export const DAYS_OF_A_WEEK = 7
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const ONE_DAY_TIMESTAMP = 1000 * 60 * 60 * 24

export enum EGiftTypePrefix {
  DramaPagePrefix = '/mdrama/',
  SoundPrefix = '/sound/',
}

export enum EGiftType {
  SoundType = 2, // 单集声音
  DramaType, // 广播剧集
}

export const GUILD_MIDDLE_TITLE = '直播公会'

export const GUILD_DEFAULT_INCOME_TYPE = EGuildIncomeType.Live

export const TAB_LIST = [
  {
    name: '礼物收益',
    type: EGuildIncomeType.Live,
    desc: '* 礼物收益指素人时期，听众在本直播间赠送礼物的总收益（扣除渠道费后、分成后）',
    guildDesc: '* 礼物收益指加入公会期间，听众在本直播间赠送礼物的总收益（扣除渠道费后、分成前）',
  },
  {
    name: '贵族开通收益',
    type: EGuildIncomeType.Noble,
    desc: '* 贵族开通收益指素人时期，听众在本直播间开通贵族产生的总收益（扣除渠道费后、分成后)',
    guildDesc: '* 贵族开通收益指加入公会期间，听众在本直播间开通贵族产生的总收益（扣除渠道费后、分成前）',
  },
  {
    name: '超粉收益',
    type: EGuildIncomeType.SuperFan,
    desc: '* 超粉收益指素人时期，听众在本直播间开通 / 续费超粉产生的总收益（扣除渠道费后、分成后）',
    guildDesc: '* 超粉收益指加入公会期间，听众在本直播间开通 / 续费超粉产生的总收益（扣除渠道费后、分成前）',
  },
  {
    name: '玩法收益',
    type: EGuildIncomeType.Play,
    desc: '* 玩法收益指素人时期，听众在本直播间使用相关玩法（提问、弹幕）的总收益（扣除渠道费后、分成后）',
    guildDesc: '* 玩法收益指加入公会期间，听众在本直播间使用相关玩法（提问、弹幕）的总收益（扣除渠道费后、分成前）',
  },
]
